const es = {
  // Login Page
  login: {
    title: 'MedRahi',
    subtitle: 'Conectando pacientes con atención india de confianza',
    emailLabel: 'Correo Electrónico',
    emailPlaceholder: 'tu@ejemplo.com',
    passwordLabel: 'Contraseña',
    passwordPlaceholder: '••••••••',
    signInButton: 'Iniciar Sesión',
    signingIn: 'Iniciando sesión...',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate',
  },
  
  // Register Page
  register: {
    title: 'Únete a MedRahi',
    subtitle: 'Crea tu cuenta para comenzar',
    fullNameLabel: 'Nombre Completo',
    emailLabel: 'Correo Electrónico',
    passwordLabel: 'Contraseña',
    roleLabel: 'Soy un',
    rolePatient: 'Paciente',
    roleDoctor: 'Médico',
    roleHospital: 'Hospital',
    countryLabel: 'País',
    countryPlaceholder: 'Tu país de origen',
    phoneLabel: 'Teléfono (Opcional)',
    createAccountButton: 'Crear Cuenta',
    creatingAccount: 'Creando cuenta...',
    haveAccount: '¿Ya tienes una cuenta?',
    signIn: 'Inicia sesión',
  },
  
  // Navigation
  nav: {
    treatments: 'Tratamientos',
    doctors: 'Médicos',
    hospitals: 'Hospitales',
    services: 'Servicios',
    wellness: 'Bienestar',
    medicalVisa: 'Visa Médica',
    signIn: 'Iniciar Sesión',
    getStarted: 'Comenzar',
    backToHome: 'Volver al Inicio',
  },
  
  // Services Menu
  servicesMenu: {
    airportPickup: 'Recogida en Aeropuerto',
    languageInterpreter: 'Intérprete de Idiomas',
    surroundingTours: 'Tours Gratuitos',
    nursingCare: 'Atención de Enfermería',
    physiotherapist: 'Fisioterapeuta',
    travelAccommodation: 'Viaje y Alojamiento',
    videoConsultations: 'Consultas por Video',
  },
  
  // Landing Page
  landing: {
    heroTag: 'Confianza de más de 10,000 Pacientes Internacionales',
    heroTitle1: 'Experimente',
    heroTitle2: 'Atención Médica',
    heroTitle3: 'de Clase Mundial en India',
    heroSubtitle: 'Conéctese con los mejores médicos y hospitales de India. Obtenga tratamiento médico asequible y de alta calidad con precios transparentes y atención personalizada.',
    ctaStart: 'Comience su Viaje',
    ctaExplore: 'Explorar Portal',
    isoCertified: 'Certificado ISO',
    nabhAccredited: 'Acreditado NABH',
    jciStandards: 'Estándares JCI',
    platformHighlights: 'Destacados de la Plataforma',
    realTimeStats: 'Estadísticas en tiempo real',
    activeNow: 'Activo Ahora',
    verifiedDoctors: 'Médicos Verificados',
    partnerHospitals: 'Hospitales Asociados',
    successRate: 'Tasa de Éxito',
    patientRating: 'Calificación de Pacientes',
    patientsTreated: 'pacientes tratados este mes',
    
    // Features Section
    whyChoose: 'Por Qué Elegir MedRahi',
    featuresTitle: 'Excelencia en Salud con Hospitalidad India',
    featuresSubtitle: 'Experimente la combinación perfecta de tecnología médica de vanguardia y calidez tradicional india',
    
    features: {
      transparentPricing: {
        title: 'Precios Transparentes',
        desc: 'Compare presupuestos de múltiples hospitales. Sin costos ocultos. Ahorre hasta un 70% en comparación con países occidentales.',
      },
      worldClassFacilities: {
        title: 'Instalaciones de Clase Mundial',
        desc: 'Acceda a hospitales acreditados por JCI con tecnología de última generación y estándares internacionales.',
      },
      verifiedSpecialists: {
        title: 'Especialistas Verificados',
        desc: 'Conéctese con médicos certificados formados internacionalmente con décadas de experiencia.',
      },
      securePrivate: {
        title: 'Seguro y Privado',
        desc: 'Encriptación de nivel bancario para sus registros médicos. Protección de datos compatible con HIPAA.',
      },
      endToEndSupport: {
        title: 'Soporte Integral',
        desc: 'Desde asistencia con visa hasta atención post-tratamiento. Manejamos todo para su comodidad.',
      },
      quickResponse: {
        title: 'Respuesta Rápida',
        desc: 'Obtenga presupuestos en 24 horas. Mensajería en tiempo real con médicos. Citas instantáneas.',
      },
    },
    
    // How It Works
    yourJourney: 'Su Viaje',
    howItWorksTitle: 'Pasos Simples hacia una Atención de Clase Mundial',
    howItWorksSubtitle: 'Desde la consulta hasta la recuperación, estamos con usted en cada paso',
    steps: {
      step1: { title: 'Enviar Solicitud', desc: 'Cuéntenos sobre su condición y necesidades médicas' },
      step2: { title: 'Comparar Presupuestos', desc: 'Reciba presupuestos detallados de médicos verificados' },
      step3: { title: 'Planificar Tratamiento', desc: 'Elija su médico y programe citas' },
      step4: { title: 'Recibir Tratamiento', desc: 'Reciba atención y disfrute su recuperación en India' },
    },
    startJourney: 'Comience su Viaje de Tratamiento',
    
    // Specializations
    popularSpecializations: 'Especializaciones de Tratamiento Populares',
    indiaExpertise: 'La experiencia de India abarca todos los campos médicos',
    specializations: {
      cardiology: 'Cardiología',
      orthopedics: 'Ortopedia',
      oncology: 'Oncología',
      fertility: 'Fertilidad',
      dental: 'Dental',
      cosmetic: 'Cosmética',
    },
    
    // For Doctors & Hospitals
    forDoctors: 'Para Médicos',
    forDoctorsDesc: 'Únase a la plataforma líder de turismo médico de India y conéctese con pacientes internacionales que buscan su experiencia.',
    forHospitals: 'Para Hospitales',
    forHospitalsDesc: 'Asóciese con MedRahi para atraer pacientes internacionales y mostrar sus instalaciones de clase mundial.',
    registerAsDoctor: 'Registrarse como Médico',
    registerAsHospital: 'Registrarse como Hospital',
    
    doctorBenefits: [
      'Expanda su práctica globalmente',
      'Consultas de pacientes verificados',
      'Sistema de precios transparente',
      'Equipo de soporte dedicado',
      'Aumente su reputación',
    ],
    hospitalBenefits: [
      'Aumente la afluencia internacional',
      'Muestre su infraestructura',
      'Gestione médicos eficientemente',
      'Análisis en tiempo real',
      'Soporte de marketing',
    ],
    
    // CTA Section
    ctaTitle: '¿Listo para Experimentar la Atención Médica India?',
    ctaSubtitle: 'Únase a miles de pacientes satisfechos que eligieron India para su tratamiento médico',
    getStartedNow: 'Comenzar Ahora',
    
    // Footer
    healthcareWithoutBorders: 'Salud Sin Fronteras',
    footerDesc: 'Conectando pacientes internacionales con los mejores profesionales de salud de India desde 2024.',
    quickLinks: 'Enlaces Rápidos',
    contactUs: 'Contáctenos',
    copyright: '© 2024 MedRahi. Todos los derechos reservados. Hecho con ❤️ en India',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    cookiePolicy: 'Política de Cookies',
  },
  
  // Service Pages Common
  services: {
    enquireNow: 'Consultar Ahora - Obtener Presupuesto Gratis',
    responseTime: 'Respuesta en 24 horas',
    whatsIncluded: 'Qué Está Incluido',
    
    // Enquiry Form
    enquiryForm: {
      fullName: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      country: 'País',
      countryPlaceholder: 'Su país de origen',
      additionalRequirements: 'Requisitos Adicionales',
      additionalPlaceholder: 'Cuéntenos más sobre sus necesidades...',
      cancel: 'Cancelar',
      submit: 'Enviar Consulta',
      successMessage: '¡Consulta enviada exitosamente! Nuestro equipo le contactará en 24 horas.',
    },
    
    // Airport Pickup
    airportPickup: {
      title: 'Servicio de Recogida en Aeropuerto',
      subtitle: 'Traslados aeroportuarios sin complicaciones para su viaje médico. Transporte seguro, confiable y cómodo.',
      mainTitle: 'Bienvenido a un Viaje Sin Estrés',
      mainDesc1: 'Llegar a un nuevo país para tratamiento médico puede ser abrumador. Nuestro servicio dedicado de recogida y entrega en aeropuerto asegura que comience y termine su viaje médico con comodidad y tranquilidad.',
      mainDesc2: 'Nuestros conductores profesionales le recibirán en el aeropuerto con un cartel de bienvenida personalizado, le ayudarán con su equipaje y le transportarán de forma segura a su alojamiento u hospital.',
      features: {
        availability: { title: 'Disponibilidad 24/7', desc: 'Servicio las 24 horas para vuelos de madrugada o noche. Siempre estamos listos cuando nos necesite.' },
        safe: { title: 'Seguro y Confiable', desc: 'Conductores experimentados y con licencia con vehículos limpios. Su seguridad y comodidad son nuestras principales prioridades.' },
        doorToDoor: { title: 'Servicio Puerta a Puerta', desc: 'Transporte directo desde el aeropuerto al hotel, hospital o cualquier ubicación en la ciudad.' },
        flightMonitoring: { title: 'Monitoreo de Vuelos', desc: 'Rastreamos el estado de su vuelo para ajustar los horarios de recogida por retrasos o llegadas anticipadas.' },
      },
      included: [
        'Recepción y bienvenida en llegadas del aeropuerto con cartel de nombre',
        'Asistencia con equipaje y navegación del aeropuerto',
        'Vehículos cómodos con aire acondicionado',
        'Conductores que hablan inglés familiarizados con rutas hospitalarias',
        'Vehículos accesibles para sillas de ruedas disponibles bajo solicitud',
        'Agua embotellada de cortesía',
        'Puntos de carga móvil en el vehículo',
        'Tiempo de espera gratuito por retrasos de vuelo',
      ],
      vehicleOptions: 'Opciones de Vehículos',
      sedan: { title: 'Sedán', desc: 'Para 1-2 pasajeros', features: ['Asientos cómodos', '2 maletas grandes', 'AC y sistema de música'] },
      suv: { title: 'SUV', desc: 'Para 3-4 pasajeros', features: ['Interior espacioso', '4 maletas grandes', 'Espacio extra para piernas'] },
      minivan: { title: 'Minivan', desc: 'Para 5-7 pasajeros', features: ['Familiar', '6+ maletas grandes', 'Accesible para sillas de ruedas'] },
      airportsCovered: 'Principales Aeropuertos que Cubrimos',
    },
    
    // Language Interpreter
    languageInterpreter: {
      title: 'Servicios de Intérprete y Traductor',
      subtitle: 'Supere la barrera de comunicación durante su viaje médico con nuestros intérpretes multilingües profesionales.',
      mainTitle: 'Comunicación Clara para una Mejor Atención Médica',
      mainDesc1: 'Cuando se trata de su salud, cada palabra importa. Nuestros intérpretes médicos profesionales aseguran que nada se pierda en la traducción durante sus consultas, procedimientos y estancias hospitalarias.',
      mainDesc2: 'Nuestros intérpretes no son solo expertos en idiomas – están capacitados en terminología médica y comprenden el contexto de atención médica.',
      features: {
        languages: { title: 'Más de 20 Idiomas Disponibles', desc: 'Árabe, ruso, francés, alemán, español, mandarín, japonés, coreano, portugués, swahili y muchos más.' },
        medical: { title: 'Expertos en Terminología Médica', desc: 'Todos los intérpretes están capacitados en vocabulario médico y protocolos de atención médica.' },
        options: { title: 'Opciones Presenciales y Remotas', desc: 'Elija entre acompañamiento físico o interpretación por video/teléfono según su preferencia.' },
        documents: { title: 'Traducción de Documentos', desc: 'Traducción de informes médicos, recetas, resúmenes de alta y otros documentos esenciales.' },
      },
      servicesInclude: 'Nuestros Servicios de Interpretación Incluyen',
      servicesList: [
        'Interpretación de consultas médicas',
        'Explicaciones de cirugías y procedimientos',
        'Instrucciones de medicación y cuidados posteriores',
        'Asistencia en admisión hospitalaria',
        'Soporte de seguros y facturación',
        'Traducción de informes médicos',
        'Traducción de recetas',
        'Soporte de emergencia bajo demanda',
        'Interpretación de consultas por video',
        'Orientación farmacéutica y de medicamentos',
      ],
      languagesTitle: 'Idiomas que Apoyamos',
      languagesList: [
        'Árabe', 'Ruso', 'Francés', 'Alemán', 'Español', 'Mandarín', 
        'Japonés', 'Coreano', 'Portugués', 'Swahili', 'Turco', 'Persa',
        'Bengalí', 'Urdu', 'Indonesio', 'Vietnamita', 'Tailandés', 'Italiano',
        'Holandés', 'Polaco'
      ],
      languagesNote: '¿No ve su idioma? Contáctenos – podemos organizar intérpretes para la mayoría de idiomas.',
    },
    
    // Surrounding Tours
    surroundingTours: {
      title: 'Tours Gratuitos por los Alrededores',
      subtitle: 'Aproveche al máximo su viaje médico con tours guiados gratuitos a atracciones cercanas durante su recuperación.',
      mainTitle: 'Sanación a Través de la Exploración',
      mainDesc1: 'La recuperación no se trata solo de tratamiento médico – también se trata de rejuvenecer su mente y espíritu. Creemos que experimentar la rica cultura y belleza natural de India puede ser una parte poderosa de su viaje de sanación.',
      mainDesc2: 'Ya sea que le interesen monumentos históricos, templos serenos, mercados vibrantes o jardines tranquilos, nuestros guías locales le presentarán las maravillas de India.',
      features: {
        guides: { title: 'Guías Locales Expertos', desc: 'Guías conocedores que comparten historias fascinantes y conocimientos sobre cada destino.' },
        itineraries: { title: 'Itinerarios Médicos', desc: 'Tours diseñados con paradas de descanso, opciones de accesibilidad y ritmo apropiado para pacientes en recuperación.' },
        cuisine: { title: 'Cocina Auténtica', desc: 'Pruebe delicias locales con consideraciones dietéticas según su tratamiento.' },
        flexible: { title: 'Horarios Flexibles', desc: 'Tours organizados según su horario de tratamiento y recomendaciones del médico.' },
      },
      popularDestinations: 'Destinos Turísticos Populares',
      mumbaiRegion: 'Región de Mumbai',
      delhiRegion: 'Región de Delhi',
      includedTitle: 'Qué Incluye Su Tour',
      includedList: [
        'Transporte con aire acondicionado',
        'Guía local profesional',
        'Tarifas de entrada a monumentos',
        'Agua embotellada',
        'Refrigerios ligeros',
        'Acceso para sillas de ruedas cuando sea necesario',
        'Asistencia fotográfica',
        'Contacto médico de emergencia',
      ],
    },
    
    // Nursing Care
    nursingCare: {
      title: 'Soporte de Atención de Enfermería',
      subtitle: 'Atención de enfermería profesional en su alojamiento para una experiencia de recuperación cómoda y segura.',
      mainTitle: 'Cuidado Compasivo, Donde Sea que Esté',
      mainDesc1: 'La recuperación no termina cuando deja el hospital. Nuestro soporte de atención de enfermería profesional lleva atención médica de calidad hospitalaria directamente a su habitación de hotel o casa de huéspedes.',
      mainDesc2: 'Ya sea que necesite asistencia con el cuidado de heridas, manejo de IV, ejercicios de fisioterapia o simplemente necesite que alguien monitoree sus signos vitales y horario de medicamentos, nuestras enfermeras brindan atención atenta y compasiva.',
      features: {
        registered: { title: 'Enfermeras Registradas', desc: 'Todas nuestras enfermeras son profesionales registradas con experiencia en UCI, cirugía y atención domiciliaria.' },
        location: { title: 'Atención en Su Ubicación', desc: 'Visitas de enfermería en su hotel, apartamento de servicio o cualquier alojamiento de su elección.' },
        flexible: { title: 'Horarios Flexibles', desc: 'Elija entre visitas por hora, atención diaria o enfermería 24/7 según sus necesidades.' },
        emergency: { title: 'Respuesta de Emergencia', desc: 'Capacitadas para manejar emergencias con comunicación directa con su equipo médico.' },
      },
      servicesTitle: 'Nuestros Servicios de Enfermería Incluyen',
      servicesList: [
        'Monitoreo de signos vitales (PA, temperatura, pulso, oxígeno)',
        'Administración y gestión de medicamentos',
        'Cuidado de heridas y cambios de vendaje',
        'Terapia IV e inyecciones',
        'Cuidado y manejo de catéter',
        'Atención y monitoreo post-quirúrgico',
        'Manejo de diabetes y administración de insulina',
        'Soporte de manejo del dolor',
        'Asistencia con movilidad y actividades diarias',
        'Monitoreo de dieta y nutrición',
        'Coordinación con sus médicos',
        'Primera respuesta de emergencia médica',
      ],
      packagesTitle: 'Opciones de Paquetes de Atención',
      hourlyVisits: { title: 'Visitas por Hora', desc: 'Visitas programadas para tareas de atención específicas', features: ['Sesiones de 1-4 horas', 'Ideal para cuidado de heridas', 'Asistencia con medicamentos'] },
      dayCare: { title: 'Atención Diurna', desc: 'Soporte de enfermería de 8-12 horas', features: ['Monitoreo diurno', 'Múltiples tareas de atención', 'Asistencia de actividades'] },
      fullCare: { title: 'Atención 24/7', desc: 'Enfermería las 24 horas', features: ['Monitoreo continuo', 'Atención nocturna incluida', 'Soporte integral'] },
    },
    
    // Physiotherapist
    physiotherapist: {
      title: 'Arreglos de Fisioterapeuta',
      subtitle: 'Servicios expertos de fisioterapia para acelerar su recuperación y restaurar la movilidad.',
      mainTitle: 'Restaurar Movilidad, Reconstruir Fuerza',
      mainDesc1: 'La fisioterapia es un componente crucial de la recuperación para muchos procedimientos médicos, especialmente cirugías ortopédicas, reemplazos de articulaciones y tratamientos neurológicos.',
      mainDesc2: 'Ya sea que necesite sesiones en su habitación o visitas a un centro de fisioterapia cercano, organizamos planes de tratamiento personalizados diseñados en consulta con su cirujano o médico tratante.',
      features: {
        certified: { title: 'Especialistas Certificados', desc: 'Fisioterapeutas con licencia con experiencia en rehabilitación post-quirúrgica y medicina deportiva.' },
        personalized: { title: 'Programas Personalizados', desc: 'Planes de tratamiento adaptados a su cirugía específica, condición y objetivos de recuperación.' },
        equipment: { title: 'Equipo Moderno', desc: 'Acceso a equipo y técnicas avanzadas de fisioterapia para una rehabilitación efectiva.' },
        flexible: { title: 'Sesiones Flexibles', desc: 'Visitas en habitación, sesiones en clínica o arreglos híbridos según su preferencia.' },
      },
      specializationsTitle: 'Nuestras Especializaciones en Fisioterapia',
      specializationsList: [
        'Rehabilitación post reemplazo de rodilla',
        'Recuperación de reemplazo de cadera',
        'Rehabilitación de cirugía de columna',
        'Terapia de hombro y manguito rotador',
        'Rehabilitación cardíaca',
        'Fisioterapia neurológica',
        'Recuperación de lesiones deportivas',
        'Rehabilitación de accidente cerebrovascular',
        'Fortalecimiento pre-quirúrgico',
        'Equilibrio y prevención de caídas',
        'Terapia de manejo del dolor',
        'Ejercicios de rango de movimiento',
      ],
      journeyTitle: 'Su Viaje de Fisioterapia',
      journeySteps: [
        { title: 'Evaluación Inicial', desc: 'Evaluación integral de su condición, movilidad y objetivos en consulta con su equipo médico.' },
        { title: 'Plan Personalizado', desc: 'Desarrollo de un plan de tratamiento personalizado con ejercicios específicos y metas.' },
        { title: 'Sesiones Regulares', desc: 'Sesiones guiadas de fisioterapia en su alojamiento o centro cercano.' },
        { title: 'Seguimiento del Progreso', desc: 'Evaluación regular del progreso con ajustes a su plan de tratamiento.' },
        { title: 'Programa de Ejercicios en Casa', desc: 'Antes de irse, reciba una guía completa de ejercicios para continuar la recuperación en casa.' },
      ],
    },
    
    // Travel & Accommodation
    travelAccommodation: {
      title: 'Arreglos de Viaje y Alojamiento',
      subtitle: 'Planificación completa de viaje y estancias cómodas cerca de su hospital – todo organizado para usted.',
      mainTitle: 'Su Comodidad es Nuestra Prioridad',
      mainDesc1: 'Planificar un viaje médico implica más que elegir un hospital. Desde reservas de vuelos hasta encontrar el lugar perfecto para quedarse, manejamos toda su logística de viaje para que pueda concentrarse completamente en su salud.',
      mainDesc2: 'Ya sea que prefiera una casa de huéspedes económica, un hotel cómodo o un apartamento con servicios completos para estancias más largas, tenemos asociaciones con alojamientos que entienden las necesidades de los viajeros médicos.',
      features: {
        flights: { title: 'Asistencia con Vuelos', desc: 'Ayuda para encontrar los mejores vuelos, documentación de visa y solicitudes de asistencia especial.' },
        hotels: { title: 'Estancias Seleccionadas', desc: 'Hoteles y apartamentos seleccionados cerca de los principales hospitales, verificados por comodidad y conveniencia.' },
        location: { title: 'Ubicaciones Prime', desc: 'Alojamientos de fácil acceso a hospitales, farmacias y servicios esenciales.' },
        quality: { title: 'Calidad Garantizada', desc: 'Todos los alojamientos inspeccionados por limpieza, seguridad y amabilidad para viajeros médicos.' },
      },
      accommodationTypes: 'Opciones de Alojamiento',
      guesthouse: { title: 'Casas de Huéspedes', desc: 'Asequibles, limpias y cómodas', features: ['Comodidades básicas', 'Cerca de hospitales', 'Comida casera', 'Servicio familiar'] },
      hotels: { title: 'Hoteles (3-5 Estrellas)', desc: 'Comodidad y servicios premium', features: ['Servicio a la habitación 24/7', 'Asistencia de conserjería', 'Restaurante y café', 'Limpieza diaria'] },
      apartments: { title: 'Apartamentos con Servicios', desc: 'Hogar lejos del hogar', features: ['Cocina completa', 'Espacio de estar', 'Descuentos larga estancia', 'Familiar'] },
      arrangementsTitle: 'Lo Que Organizamos Para Usted',
      arrangementsList: [
        'Asistencia con reserva de vuelos',
        'Orientación de visa médica',
        'Selección y reserva de alojamiento',
        'Coordinación de recogida en aeropuerto',
        'Arreglo de tarjeta SIM local',
        'Orientación de cambio de moneda',
        'Orientación del área local',
        'Configuración de contacto de emergencia',
        'Arreglos de extensión de estancia',
        'Alojamiento para acompañante',
        'Comunicación de requisitos dietéticos',
        'Mapeo de proximidad al hospital',
      ],
      citiesTitle: 'Principales Ciudades de Destino Médico',
    },
    
    // Video Consultations
    videoConsultations: {
      title: 'Consultas por Video',
      subtitle: 'Conéctese con los mejores especialistas de India desde cualquier parte del mundo a través de videollamadas seguras.',
      mainTitle: 'Consejo Médico Experto, Donde Sea que Esté',
      mainDesc1: '¿No está seguro si necesita viajar a India para tratamiento? Comience su viaje con una consulta por video. Nuestra plataforma segura de telesalud le conecta con los principales especialistas de India.',
      mainDesc2: 'Las consultas por video son perfectas para evaluaciones iniciales, planificación de tratamiento, segundas opiniones y seguimientos post-tratamiento. Comparta sus informes médicos digitalmente y nuestros especialistas los revisarán antes de su llamada programada.',
      features: {
        global: { title: 'Accesibilidad Global', desc: 'Conéctese desde cualquier país, cualquier zona horaria. Programamos citas que funcionen para usted.' },
        secure: { title: 'Cumple con HIPAA', desc: 'Videollamadas encriptadas de extremo a extremo asegurando que su información médica permanezca privada.' },
        flexible: { title: 'Horarios Flexibles', desc: 'Horarios de mañana temprano o tarde noche disponibles para acomodar diferentes zonas horarias.' },
        easy: { title: 'Fácil de Usar', desc: 'Plataforma simple que funciona en su teléfono, tableta u computadora. No se necesita software especial.' },
      },
      howItWorks: 'Cómo Funciona la Consulta por Video',
      steps: [
        { title: 'Reserve Su Cita', desc: 'Envíe su consulta con sus informes médicos. Nuestro equipo le emparejará con el especialista adecuado.' },
        { title: 'Revisión de Documentos', desc: 'El especialista revisa sus informes antes de la llamada para aprovechar al máximo su tiempo de consulta.' },
        { title: 'Consulta por Video', desc: 'Únase a la videollamada segura a su hora programada. Discuta su condición, haga preguntas y obtenga consejo experto.' },
        { title: 'Resumen Escrito', desc: 'Reciba un resumen detallado de la consulta con diagnóstico, recomendaciones y próximos pasos.' },
        { title: 'Soporte de Seguimiento', desc: 'Nuestro equipo permanece disponible para ayudarle a entender las recomendaciones y planificar su tratamiento.' },
      ],
      consultationTypes: 'Tipos de Consultas por Video',
      typesList: [
        'Evaluación médica inicial',
        'Consulta de segunda opinión',
        'Discusión de planificación de tratamiento',
        'Consulta pre-quirúrgica',
        'Seguimiento post-tratamiento',
        'Revisión de referencia de especialista',
        'Interpretación de informes médicos',
        'Estimación de costos de tratamiento',
        'Evaluación de factibilidad de cirugía',
        'Manejo de condiciones crónicas',
      ],
      specialtiesTitle: 'Especialidades Disponibles para Consulta por Video',
    },
  },
  
  // Treatments Page
  treatments: {
    heroTitle: 'Tratamientos Médicos',
    heroTitleHighlight: 'de Clase Mundial',
    heroSubtitle: 'India ofrece tratamientos médicos avanzados a una fracción del costo. Explore nuestra amplia gama de especialidades y procedimientos.',
    jciAccredited: 'Hospitales Acreditados JCI',
    costSavings: '60-80% de Ahorro',
    expertSurgeons: 'Cirujanos Expertos',
    filters: 'Filtros',
    showing: 'Mostrando',
    treatmentsCount: 'tratamientos',
    commonProcedures: 'Procedimientos Comunes',
    learnMore: 'Más Información',
    savingsCompared: 'ahorro comparado con EE.UU.',
  },
  
  // Doctors Page
  doctors: {
    heroTitle: 'Conéctese con los',
    heroTitleHighlight: 'Mejores Médicos de India',
    heroSubtitle: 'Especialistas altamente calificados con formación internacional y años de experiencia en sus campos.',
    filterDoctors: 'Filtrar Médicos',
    hideFilters: 'Ocultar Filtros',
    showFilters: 'Mostrar Filtros',
    city: 'Ciudad',
    allCities: 'Todas las Ciudades',
    state: 'Estado',
    allStates: 'Todos los Estados',
    specialization: 'Especialización',
    allSpecializations: 'Todas las Especialidades',
    experience: 'Experiencia',
    anyExperience: 'Cualquier Experiencia',
    yearsPlus: 'años+',
    showing: 'Mostrando',
    doctorsCount: 'médicos',
    yearsExperience: 'años de experiencia',
    viewProfile: 'Ver Perfil',
    requestAppointment: 'Solicitar Cita',
    noResults: 'No se encontraron médicos con sus criterios',
    tryAdjusting: 'Intente ajustar sus filtros para ver más resultados',
    clearFilters: 'Limpiar Filtros',
  },
  
  // Hospitals Page
  hospitals: {
    heroTitle: 'Los Mejores',
    heroTitleHighlight: 'Hospitales de India',
    heroSubtitle: 'Hospitales acreditados JCI con infraestructura de clase mundial, tecnología de vanguardia y atención excepcional al paciente en 9 estados.',
    hospitalsCount: 'Hospitales',
    jciAccredited: 'Acreditados JCI',
    expertTeams: 'Equipos Médicos Expertos',
    filters: 'Filtros',
    showing: 'Mostrando',
    hospitalsCountLabel: 'hospitales',
    bedCapacity: 'Capacidad de Camas',
    viewHospital: 'Ver Hospital',
    specialties: 'Especialidades',
    accreditations: 'Acreditaciones',
  },
  
  // Wellness Page
  wellness: {
    heroTitle: 'Bienestar Holístico y',
    heroTitleHighlight: 'Recuperación',
    heroSubtitle: 'Combine tratamiento médico de clase mundial con las antiguas tradiciones de bienestar de India para una curación completa de mente, cuerpo y espíritu.',
    ayurveda: 'Ayurveda',
    yoga: 'Yoga y Meditación',
    naturopathy: 'Naturopatía',
    spa: 'Spa y Rejuvenecimiento',
    whyChoose: 'Por Qué Elegir India para el Bienestar',
    healingTraditions: 'India tiene una tradición de 5.000 años de curación holística a través del Ayurveda, yoga y naturopatía.',
    integratedCare: 'Nuestros programas de bienestar están diseñados para complementar su tratamiento médico y acelerar la recuperación.',
  },
  
  // Medical Visa Page
  medicalVisa: {
    heroTitle: 'Asistencia de',
    heroTitleHighlight: 'Visa Médica',
    heroSubtitle: 'Le guiamos a través de todo el proceso de visa médica, haciendo su viaje de salud a India suave y sin complicaciones.',
    whatIs: '¿Qué es una Visa Médica?',
    whatIsDesc: 'Una visa médica (M-Visa) se emite a ciudadanos extranjeros que buscan tratamiento médico en India. Permite múltiples entradas y es válida hasta por un año.',
    eligibility: 'Elegibilidad',
    eligibilityDesc: 'Pacientes que buscan tratamiento en hospitales indios reconocidos',
    validity: 'Validez',
    validityDesc: 'Hasta 1 año o 3 veces la duración del tratamiento',
    entries: 'Entradas',
    entriesDesc: 'Triple entrada, extensible',
    attendants: 'Acompañantes',
    attendantsDesc: 'Hasta 2 visas de acompañante médico (MX-Visa)',
    documentsRequired: 'Documentos Requeridos',
    howWeHelp: 'Cómo Ayudamos',
  },
};

export default es;
